import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
  Alert,
  Col
} from "reactstrap";

function IndexNavbar({loading, formSent}) {
  const [alert1, setAlert1] = React.useState(true)
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent")
  const [collapseOpen, setCollapseOpen] = React.useState(false)

/*   const toNote = () => {
    window.scrollTo({
      left: 0,
      top: document.getElementById("test").getBoundingClientRect().y ,
      })
    setAlert1(false)
  } */

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} expand="lg" color="info">
        {formSent && <Alert color="success" isOpen={alert1}>
          <Container>
            <strong>Réservation effectuée</strong> 
            <button
              type="button"
              className="close"
              onClick={() => setAlert1(false)}
            >
              <span aria-hidden="true">
                <i className="now-ui-icons ui-1_simple-remove"></i>
              </span>
            </button>
            
          </Container>
        </Alert>}
        <Alert color="success" isOpen={loading}>
          <Container>
            <div className="alert-icon">
              <i className="now-ui-icons loader_refresh spin"></i>
            </div>
            <strong>Chargement des tables </strong>            
          </Container>
        </Alert>
        <Container>
          <div className="navbar-translate">
            <NavbarBrand
              id="navbar-brand"
            >
              {/* NUIT INSA */}
              <Col sm="2">
              <img
                  style={{maxWidth: "4.5em"}}
                  alt="Logo Nuit Insa"
                  className="rounded"
                  src={require("assets/img/logo-nuit.png").default}
                ></img>
              </Col>
            </NavbarBrand>
            <UncontrolledTooltip target="#navbar-brand">
              Le Samedi 5 Mars 2022
            </UncontrolledTooltip>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar style={{fontSize: "1.3em"}}>
              <NavItem>
                <NavLink
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .getElementById("index-header")
                      .scrollIntoView();
                  }}
                >
                  <p>Accueil</p>
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  href="#pablo"
                  nav
                >
                  <p>Thème 2022</p>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem 
                    onClick={(e) => {
                      e.preventDefault()
                      document
                      .getElementById("carousel")
                      .scrollIntoView();
                    }}>
                    <i className="now-ui-icons business_chart-pie-36 mr-1"></i>
                    Menu
                  </DropdownItem>
                  <DropdownItem 
                    onClick={(e) => {
                      e.preventDefault()
                      document
                      .getElementById("carousel")
                      .scrollIntoView();
                    }}>
                    <i className="now-ui-icons design_bullet-list-67 mr-1"></i>
                    Programme
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <NavLink
                  to="./partenaires-page"
                  tag={Link}
                >
                  <p>Partenaires</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="./precedition-page"
                  tag={Link}
                >
                  <p>Précédentes éditions</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .getElementById("table-choice-section")
                      .scrollIntoView();
                  }}
                >
                  <p>Tarifs et réservations</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://www.facebook.com/galainsahdf"
                  target="_blank"
                  id="facebook-tooltip"
                >
                  <i className="fab fa-facebook-square"></i>
                  <p className="d-lg-none d-xl-none">Facebook</p>
                </NavLink>
                <UncontrolledTooltip target="#facebook-tooltip">
                  Venez voir notre Facebook
                </UncontrolledTooltip>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://www.instagram.com/nuit_insa"
                  target="_blank"
                  id="instagram-tooltip"
                >
                  <i className="fab fa-instagram"></i>
                  <p className="d-lg-none d-xl-none">Instagram</p>
                </NavLink>
                <UncontrolledTooltip target="#instagram-tooltip">
                  Venez voir notre Instagram
                </UncontrolledTooltip>
              </NavItem>
              <NavItem>
              <NavLink
                  href="https://www.linkedin.com/company/nuit-insa/mycompany/"
                  target="_blank"
                  id="linkedin-tooltip"
                >
                  <i className="fab fa-linkedin"></i>
                  <p className="d-lg-none d-xl-none">LinkedIn</p>
                </NavLink>
                <UncontrolledTooltip target="#linkedin-tooltip">
                  Venez voir notre LinkedIn
                </UncontrolledTooltip>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default IndexNavbar;
